<template>
  <div>
    <el-radio v-for="v in data" :key="v" v-model="value" :label="v" />
  </div>
</template>

<script>
export default {
  name: "multiWidgetForm",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      value: null
    };
  },
  watch: {
    data() {
      this.value = null;
    },
    value() {
      this.$emit("change", this.value);
    }
  }
};
</script>

<style scoped></style>
